/* src/app/admin-setting/assing-company-users/company-users-list/update-company-in-user-popup/update-company-in-user-popup.css */
.example-chip-list {
  width: 100%;
}
::ng-deep app-update-company-in-user-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
/*# sourceMappingURL=update-company-in-user-popup.css.map */
